/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationApplicationStep {
    getFixupPrototypeFunction() { return GovernanceConfigurationApplicationStep.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationApplicationStep>): GovernanceConfigurationApplicationStep {
        let obj = Object.assign(new GovernanceConfigurationApplicationStep(), model);
        GovernanceConfigurationApplicationStep.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationApplicationStep>): GovernanceConfigurationApplicationStep {
        if (!model) return null;
        return GovernanceConfigurationApplicationStep.newInstance(<GovernanceConfigurationApplicationStep> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationApplicationStep) {
        if (!obj) return;

        models.GovernanceConfigurationApplicationStep.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationApplicationStep): boolean {
        Object.setPrototypeOf(obj, GovernanceConfigurationApplicationStep.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Description of the step
     */
    label: string;

    /**
     * Status of the step
     */
    status: models.GovernanceConfigurationApplicationStepStatus;

    /**
     * Reason for failure
     */
    failure: string;

}
